module.exports = __webpack_public_path__ + "assets/Crossbite.843c550b8abef62f1446e5080f180011.png";